<script>
    import {
        Card,
        CardBody,
        Icon,
        InputGroup,
        InputGroupText,
        Button,
        Row,
        Col,
        Container,
        Styles,
        TabContent,
        TabPane
    } from 'sveltestrap';
    import AlertWindows from './AlertWindows.svelte';

    import {slo, windows, calcBurnRate, convertSectoDay, calculate} from './slo.js'


    import AlertVisualisationTable from "./AlertVisualisationTable.svelte";
    import SLOInput from "./SLOInput.svelte";
    import AlertVisualisationGraph from "./AlertVisualisationGraph.svelte";
    import PrometheusRules from "./PrometheusRules.svelte";

    let chartData;
    let ctx;
    let chartCanvas;


</script>
<Styles/>

<Container md style="max-width: 960px">
    <Row>
        <Col>
            <h1>SLO Tool</h1>
            <p><em>SLO tool</em> helps you generate Prometheus SLO based alerting rules and visualise alert reaction
                times.</p>
            <SLOInput slo={slo}/>
            <AlertWindows slo={slo} windows={windows}/>


            <!--            <h2>Response times for SLO of {slo}%</h2>-->
            <div style="min-height: 512px">

                <TabContent>
                    <TabPane tabId="table" tab="Reaction times" active>
                        <AlertVisualisationTable slo={slo} windows={windows}/>
                    </TabPane>
<!--                    <TabPane tabId="chart" tab="Chart" active>-->
<!--                        <AlertVisualisationGraph slo={slo} windows={windows}/>-->
<!--                    </TabPane>-->
                    <TabPane tabId="prometheus" tab="Prometheus rules">
                        <PrometheusRules slo={slo} windows={windows}/>

                    </TabPane>
                </TabContent>
            </div>
            <!--            <PrometheusRules slo={slo} windows={windows}/>-->
        </Col>
    </Row>


</Container>

<style>
</style>